import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams} from "react-router-dom";
import PersistentDrawerLeft from "../../components/navMenu/NavMenu";
import firebase from '../../config/firebase';
import DataPerfilTable from "../../components/Data-perfil-table/dataPerfilTable.js";
import { Button, Form, Modal, Result, Select } from "antd";
import PaymentModal from "../../components/modal-salve-payment/modal-payment";
import { useLocation } from "react-router-dom";
import PaymentModalDespesas from "../../components/modal-salve-payment/ModalPayment";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import CreateListPerfil from "../../view/perfil/CreateListPerfil";
import AddIcon from '@mui/icons-material/Add';
import perfilService from "../../service/perfil.service";

require('firebase/auth')

export default function PerfilList() {

    const db = firebase.firestore();
    var userLogado = useSelector(state => state.usuarioLogado);
    const user = useSelector(state => state.user);

    const [listPerfil, setListPerfil] = useState([]);
    const [carregando, setCarregando] = useState(1);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [onSave, setOnSave] = useState(1);

    let navigate = useNavigate();

    let perfilList = [];

    function handleSave() {
        setCarregando(0);
        setOnSave(prev => prev + 1);
    }

    useEffect(() => {

        if (userLogado > 0) {

            db.collection('perfil').get().then( async(result) => {
                result.docs.forEach(doc => {
                    perfilList.push({
                        id: doc.id,
                        ...doc.data()
                    });
                })

                if(!perfilList) {
                    perfilList = await perfilService.getPerfis();
                }

                setListPerfil(perfilList);
                setCarregando(0);
            })
            .catch(error => {
                setCarregando(0);
                console.error(error);
            });
        }
    }, [carregando]);

    return (
        <>
            {
                userLogado > 0 ?
                    <NewMiniDrawer divOpen={
                        <div className="freight-content">
                            <div className="container mb-3">
                                <div className="row">
                                    <div className="col-5">
                                        <h4>Perfil</h4>
                                    </div>
                                    <div className="col-5"></div>
                                    <div className="col-2">
                                        <div className="col-md-11 control-label">
                                            {
                                                user?.permissoes?.perfil?.isCreate ?
                                                (
                                                    <Button onClick={() => navigate("/createPerfil")} id="ButtonHover" type="primary" icon={<AddIcon />}>
                                                        Novo
                                                    </Button>
                                                )
                                                :
                                                (
                                                    ""
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div style={{ height: 400, width: '100%' }}>
                                    <DataPerfilTable data={listPerfil} onSave={onSave}/>
                                </div>
                            </div>
                        </div>
                    } />
                :
                navigate("/login")
            }

            <CreateListPerfil
                open={showCreateModal}
                onClose={() => {
                    setShowCreateModal(false);
                }}
                onSaveChange={handleSave}
            />
        </>
    );
}
